import { Channel } from '@/types/schema.generated'

export const channelLabelMap = {
  [Channel.Okaneko]: 'オカネコ',
  [Channel.Rakuten]: '楽天証券',
  [Channel.Yahoo]: 'Yahoo! JAPAN',
  [Channel.Sbi]: 'SBI証券',
  [Channel.Minkabu]: 'MINKABU',
  [Channel.Ponta]: 'Ponta',
  [Channel.Okb]: 'OKB',
  [Channel.Kiraboshi]: 'きらぼし銀行',
  [Channel.FourHundredF]: '400F',
  [Channel.MetLife]: 'メットライフ生命',
  [Channel.Hanasaku]: 'はなさく生命',
  [Channel.HokenNoMadoguchi]: 'ほけんの窓口',
  [Channel.Smcc]: '三井住友カード',
  [Channel.Famipay]: 'ファミペイ',
  [Channel.RakutenInHouseAdvisor]: '楽天証券インハウスアドバイザー',
  [Channel.ZaikeiJutakuKinyu]: '財形住宅金融',
  [Channel.VitalitySmart]: 'Vitalityスマート',
  [Channel.RakutenUnyouSoudan]: '楽天証券運用相談',
  [Channel.FourHundredFInsuranceComparison]: '400F保険比較',
  [Channel.MoneyForward]: 'マネーフォワード',
  [Channel.SbiUnyouSoudan]: 'SBI証券運用相談',
  [Channel.ChugokuGinko]: '中国銀行',
  [Channel.SbiMoneyPlaza]: 'SBIマネープラザ',
  [Channel.ToyotaCorolla]: 'トヨタカローラ',
  [Channel.OkanekoTenshoku]: 'オカネコ転職',
  [Channel.Ninpath]: 'ninpath',
  [Channel.OrixBank]: 'オリックス銀行',
  [Channel.LifePlaza]: 'ライフプラザパートナーズ',
  [Channel.JpBank]: 'ゆうちょ銀行',
  [Channel.Jcb]: 'JCB',
  [Channel.NisseiAm]: 'ニッセイアセットマネジメント',
} as const satisfies Record<Channel, string>

export const isPartnerChannel = (channel: Channel): boolean =>
  channel !== Channel.Okaneko

export const labelOf = (channel: Channel): string => channelLabelMap[channel]
